import React from 'react';
import PropTypes from 'prop-types';

const SubmitAndCancelButtonGroup = (props) => (
    <div className="flex items-center justify-end">
        {props.onCancel && (
            <div className="mr-5">
                <button
                    className="disabled:opacity-50 bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
                    onClick={props.onCancel}
                    disabled={props.disableCancel}
                >
                    {props.cancelButtonText || 'Cancel'}
                </button>
            </div>
        )}
        <div>
            <button
                className="disabled:opacity-50 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                onClick={props.onSubmit}
                disabled={props.disableSubmit}
            >
                {props.submitButtonText || 'Submit'}
            </button>
        </div>
    </div>
);

SubmitAndCancelButtonGroup.propTypes = {
    submitButtonText: PropTypes.string,
    onSubmit: PropTypes.func,
    disableSubmit: PropTypes.bool,
    cancelButtonText: PropTypes.string,
    onCancel: PropTypes.func,
    disableCancel: PropTypes.bool,
};

export default SubmitAndCancelButtonGroup;
